// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronRight20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronRight20: FC<ChevronRight20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="m8.62 16-1.24-1.007L11.468 10 7.38 5.007 8.619 4l4.914 6-4.914 6Z" />
        </svg>
    );
};

export default ChevronRight20;
